/** 
*@author: satyamurthy.a
*@Description : 
**/
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { Form, Button, Drawer, Row, Col, message, Select } from 'antd';
import { StyledApplication, DrawerFooter } from '../UserManagement/style';
import { API_MASTERCONFIGURATION, MASTER_Mapping } from '../../../commons/api';

const { Option } = Select;
const FormItem = Form.Item;

const MasterMapping = () => {
  const [visible, setVisible] = useState(false);
  const [mappingList, setMappingList] = useState([]);
  const [mappingObject, setMappingObject] = useState({});
  const [masterTableNames, setMasterTableNames] = useState([]);
  const [columnsList, setColumnsList] = useState([]);
  const [masterList, setMasterList] = useState([]);
  
  const userRef = useRef(null);

  useEffect(() => {
    _getmappingList();
    _getMasterList();
    _getTableMasterList();
  }, []);

  const onClose = () => {
    if (userRef.current) {
      userRef.current.resetFields();
    }
    setVisible(false);
    setMappingObject({});
  };

  const showDrawer = () => {
    if (userRef.current) {
      userRef.current.resetFields();
    }
    setVisible(true);
    setMappingObject({});
  };

  const _getmappingList = () => {
    const accessToken = localStorage.get('accessToken');
    const axiosObject = {
      method: 'GET',
      url: `${MASTER_Mapping.GET}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(axiosObject)
      .then((response) => {
        setMappingList(response.data);
      })
      .catch(() => {
        message.error('Error fetching mapping list');
      });
  };

  const _getTableMasterList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const axiosObject = {
      method: 'GET',
      url: `${API_MASTERCONFIGURATION.GetTableList}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(axiosObject)
      .then((response) => {
        setMasterTableNames(response.data);
      })
      .catch(() => {
        message.error('Error fetching table master list');
      });
  };

  const _getMasterList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const axiosObject = {
      method: 'GET',
      url: `${API_MASTERCONFIGURATION.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(axiosObject)
      .then((response) => {
        setMasterList(response.data);
      })
      .catch(() => {
        message.error('Error fetching master list');
      });
  };

  const savemastermapping = (type) => {
    const accessToken = localStorage.get('accessToken');
    if (type === 'save') {
      userRef.current.validateFields().then(async (values) => {
        let payloadData = {
          ParentTable: values.ParentTable,
          ParentColumn: values.ParentColumn,
          ChildTable: values.ChildTable,
          ChildColumn: values.ChildColumn,
          DisplayColumn: values.DisplayColumn
        };
        let savemapping = {
          method: 'POST',
          url: `${MASTER_Mapping.CREATE}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: payloadData
        };
        axios(savemapping)
          .then(() => {
            _getmappingList();
            message.success('Mapping created');
            onClose();
          })
          .catch(() => {
            message.error('Error saving mapping');
          });
      });
    } else if (type === 'update') {
      userRef.current.validateFields().then(async (values) => {
        let updatemapping = {
          method: 'POST',
          url: `${MASTER_Mapping.UPDATE}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: {
            ...values,
            Id: mappingObject.Id
          }
        };
        axios(updatemapping)
          .then(() => {
            _getmappingList();
            message.success('Mapping updated');
            onClose();
          })
          .catch(() => {
            message.error('Error updating mapping');
          });
        });}
      else if (type === 'delete') {
      let deletemapping = {
        method: 'POST',
        url: `${MASTER_Mapping.Delete}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data: {
          Id: mappingObject.Id
        }
      };
      axios(deletemapping)
        .then(() => {
          _getmappingList();
          message.success('Mapping deleted');
          onClose();
        })
        .catch(() => {
          message.error('Error deleting mapping');
        });
    }
  };

  const getColumnData = async (value) => {
    let columnsList = await getAxiosColumnsFromTableName(value);
    setColumnsList(columnsList);
  };

  const getAxiosColumnsFromTableName = (TableName) => {
    const axiosObject = {
      method: 'POST',
      url: `${API_MASTERCONFIGURATION.GetColumnNamesByTableName}`,
      data: {
        TableName
      }
    };
    return axios(axiosObject)
      .then((response) => {
        if (response && response.data && Array.isArray(response.data)) {
          return response.data;
        } else {
          return [];
        }
      })
      .catch(() => {
        message.error('Error fetching column names');
      });
  };

  const columns = [
    {
      title: 'Parent Table',
      dataIndex: 'ParentTable',
      key: 'ParentTable'
    },
    {
      title: 'Parent Column',
      dataIndex: 'ParentColumn',
      key: 'ParentColumn'
    },
    {
      title: 'Child Table',
      dataIndex: 'ChildTable',
      key: 'ChildTable'
    },
    {
      title: 'Child Column',
      dataIndex: 'ChildColumn',
      key: 'ChildColumn'
    },
    {
      title: 'Child Display Column',
      dataIndex: 'DisplayColumn',
      key: 'DisplayColumn'
    }
  ];

  return (
    <StyledApplication style={{ minHeight: window.innerHeight - 226 }}>
      <div>
        <Row>
          <Col span={8}>
            <Button
              type="primary"
              onClick={showDrawer}
              style={{
                backgroundColor: '#000c17',
                border: '#000c17',
                marginBottom: '5%'
              }}
            >
              Create
            </Button>
          </Col>
          <StyledTable size="small"
            
            columns={columns}
            dataSource={Array.isArray(mappingList) ? mappingList : []}
            pagination={
              mappingList && mappingList.length > 10
                ? {
                  pageSize: '5'
                }
                : false
            }
            locale={{ emptyText: 'No Data' }}
            onRow={(record) => {
              return {
                onClick: () => {
                  setVisible(true);
                  setMappingObject(record);
                }
              };
            }}
          />
          <Drawer
            title={!mappingObject.MasterMappingId ? 'Create' : 'Update'}
            placement="right"
            closable
            width={800}
            onClose={onClose}
            open={visible}
          >
            <Form
              layout="vertical"
              ref={userRef}
              name="user_form"
              initialValues={mappingObject || {}}
            >
              <Row>
                <Col span={24}>
                  <FormItem
                    label="Parent Table:"
                    name="ParentTable"
                    rules={[
                      {
                        required: true,
                        message: 'Please select your Parent Table!'
                      }
                    ]}
                  >
                    <Select
                      placeholder="Select Parent Table"
                      style={{ width: '300px' }}
                      onChange={(e) => getColumnData(e)}
                    >
                      {masterTableNames &&
                        Object.keys(masterTableNames)
                          .filter((fil) => {
                            return !(
                              masterList &&
                              masterList
                                .map((master) => {
                                  return master.TableName;
                                })
                                .includes(fil)
                            );
                          })
                          .map((master, index) => {
                            return (
                              <Option key={index} value={master}>
                                {master}
                              </Option>
                            );
                          })}
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <FormItem
                    label="Parent Column:"
                    name="ParentColumn"
                    rules={[
                      {
                        required: true,
                        message: 'Please select your Parent Column!'
                      }
                    ]}
                  >
                    <Select placeholder="Select Parent Column" style={{ width: '300px' }}>
                      {columnsList &&
                        Array.isArray(columnsList) &&
                        columnsList.map((item, index) => {
                          return (
                            <Option key={index} value={item .ColumnName}>
                              {item.ColumnName}
                            </Option>
                          );
                        })}
                      {masterTableNames &&
                        userRef.current &&
                        masterTableNames[userRef.current.getFieldValue('ParentTable')] &&
                        masterTableNames[userRef.current.getFieldValue('ParentTable')]
                          .map((keyNames, index) => {
                            return (
                              <Option key={index} value={keyNames}>
                                {keyNames}
                              </Option>
                            );
                          })}
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <FormItem
                    label="Child Table:"
                    name="ChildTable"
                    rules={[
                      {
                        required: true,
                        message: 'Please select your Child Table!'
                      }
                    ]}
                  >
                    <Select
                      placeholder="Select Child Table"
                      style={{ width: '300px' }}
                      onChange={(e) => getColumnData(e)}
                    >
                      {masterTableNames &&
                        Object.keys(masterTableNames)
                          .filter((fil) => {
                            return !(
                              masterList &&
                              masterList
                                .map((master) => {
                                  return master.TableName;
                                })
                                .includes(fil)
                            );
                          })
                          .map((master, index) => {
                            return (
                              <Option key={index} value={master}>
                                {master}
                              </Option>
                            );
                          })}
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <FormItem
                    label="Child Column:"
                    name="ChildColumn"
                    rules={[
                      {
                        required: true,
                        message: 'Please select your Child Column!'
                      }
                    ]}
                  >
                    <Select placeholder="Select Child Column" style={{ width: '300px' }}>
                      {masterTableNames &&
                        userRef.current &&
                        masterTableNames[userRef.current.getFieldValue('ChildTable')] &&
                        masterTableNames[userRef.current.getFieldValue('ChildTable')]
                          .map((keyNames, index) => {
                            return (
                              <Option key={index} value={keyNames}>
                                {keyNames}
                              </Option>
                            );
                          })}
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <FormItem
                    label="Child Display Column:"
                    name="DisplayColumn"
                    rules={[
                      {
                        required: true,
                        message: 'Please select your Child Display Column!'
                      }
                    ]}
                  >
                    <Select placeholder="Select Child Display Column" style={{ width: '300px' }}>
                      {masterTableNames &&
                        userRef.current &&
                        masterTableNames[userRef.current.getFieldValue('ChildTable')] &&
                        masterTableNames[userRef.current.getFieldValue('ChildTable')]
                          .map((keyNames, index) => {
                            return (
                              <Option key={index} value={keyNames}>
                                {keyNames}
                              </Option>
                            );
                          })}
                    </Select>
                  </FormItem>
                </Col>
              </Row>
            </Form>
            <DrawerFooter>
              <div>
                {!mappingObject.Id ? (
                  <div>
                    <Button
                      type="primary"
                      style={{
                        marginLeft: '5px',
                        marginBottom: '5px',
                        backgroundColor: '#000c17',
                        border: '#000c17'
                      }}
                      onClick={() => savemastermapping('save')}
                    >
                      Save
                    </Button>
                    <Button
                      type="primary"
                      style={{
                        marginLeft: '5px',
                        marginBottom: '5px',
                        backgroundColor: '#000c17',
                        border: '#000c17'
                      }}
                      onClick={onClose}
                    >
                      Cancel
                    </Button>
                  </div>
                ) : (
                  <div>
                    <Button
                      type="primary"
                      style={{
                        marginLeft: '5px',
                        marginBottom: '5px',
                        border: '#000c17'
                      }}
                      onClick={() => savemastermapping('update')}
                    >
                      Update
                    </Button>
                    <Button
                      type="primary"
                      style={{
                        marginLeft: '5px',
                        marginBottom: '5px',
                        border: '#000c17'
                      }}
                      onClick={() => savemastermapping('delete')}
                    >
                      Delete
                    </Button>
                  </div>
                )}
              </div>
            </DrawerFooter>
          </Drawer>
        </Row>
      </div>
    </StyledApplication>
  );
};

export default MasterMapping;